// (B) 플레인 Progress — antd Progress 대체(순수 시각). line 타입만(§7: OmwProgress 에 type 없음, 소비처 전부 line).
// antd DOM 미러링: .om-progress(.om-progress-line/-status-{status}) > .om-progress-outer > .om-progress-inner > .om-progress-bg / .om-progress-text.
// 소비처 SCSS(.om-progress*)가 색/높이 정의 → 여기선 구조+antd base(styles/omwProgress.css)만.
import type { CSSProperties } from 'react'
import type { OmwProgressProps } from '../api/OmwProgress'
import { cx } from './cx'
import '../styles/omwProgress.css'

export function PlainProgress({
  percent = 0,
  showInfo = true,
  status = 'normal',
  strokeColor,
  size = 'default',
  className,
  style,
}: OmwProgressProps) {
  const clamped = Math.max(0, Math.min(100, percent))
  const bgStyle: CSSProperties = {
    width: `${clamped}%`,
    height: size === 'small' ? 6 : 8,
    ...(strokeColor != null ? { background: strokeColor } : {}),
  }

  const info = status === 'success' ? '✓' : status === 'exception' ? '✕' : `${clamped}%`

  return (
    <div
      className={cx(
        'om-progress',
        'om-progress-line',
        `om-progress-status-${status}`,
        size === 'small' && 'om-progress-small',
        showInfo && 'om-progress-show-info',
        className,
      )}
      style={style}
    >
      <div className="om-progress-outer">
        <div className="om-progress-inner">
          <div className="om-progress-bg" style={bgStyle} />
        </div>
      </div>
      {showInfo && <span className="om-progress-text">{info}</span>}
    </div>
  )
}
